export default __webpack_public_path__ + "static/media/internship.11226d40.svg";